import * as React from "react";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import { Tooltip } from "@mui/material";
import {
  formatFileSize,
  formatDate_12h,
  capitalize,
} from "../../services/Utils";
import CognitoAiUploadStatus from "./CognitoAiUploadStatus";
import CognitoAiDataTableRowActions from "./CognitoAiDataTableRowActions";
import Constants from "../../services/Constants";
import TextField from "@mui/material/TextField";
import { PRODUCT_VARIANT } from "../../services/Constants";

const UploadStatusInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        {Object.entries(Constants.UPLOAD_STATUS).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const ProductVariantInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        {Object.entries(PRODUCT_VARIANT).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const getCognitoAiDataColumns = () => {
  const filterOperators = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: UploadStatusInput,
      InputComponentProps: { type: "string" },
    },
  ];

  const customFilterForProductVariant = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: ProductVariantInput,
      InputComponentProps: { type: "string" },
    },
  ];

  return [
    {
      field: "fileName",
      headerName: "Name",
      flex: 2,
      editable: false,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value || "-"}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "productVariant",
      headerName: "Product Variant",
      description: "Product variant",
      sortable: false,
      editable: false,
      flex: 1,
      filterOperators: customFilterForProductVariant,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value || "-"}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "fileSize",
      headerName: "Size",
      type: "number",
      flex: 0.5,
      editable: false,
      filterable: false,
      renderCell: (data) => {
        const fileSize = formatFileSize(parseInt(data?.value));
        return (
          <Tooltip title={fileSize}>
            <p
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {fileSize || "-"}
            </p>
          </Tooltip>
        );
      },
    },
    {
      field: "version",
      headerName: "Version",
      description: "Version of the Cognito AI software",
      sortable: true,
      flex: 0.5,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value || "-"}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "uploadStatus",
      headerName: "Status",
      flex: 0.7,
      sortable: false,
      editable: false,
      renderCell: (params) => (
        <CognitoAiUploadStatus uploadData={params?.row} />
      ),
      filterOperators: filterOperators,
    },
    {
      field: "uploadedBy",
      headerName: "Uploaded By",
      sortable: true,
      flex: 0.7,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value || "-"}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "createdAt",
      headerName: "Uploaded At",
      description: "Time of creation",
      type: "dateTime",
      flex: 0.75,
      renderCell: (data) => <DateAndTimeGridCell value={data?.value} />,
    },
    {
      field: "none",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        return [<CognitoAiDataTableRowActions rowData={row} key={id} />];
      },
    },
  ];
};

export { getCognitoAiDataColumns };
